import React from 'react';
import {
    FaAddressBook,
    FaAddressCard,
    FaArrowDown,
    FaArrowRight,
    FaArrowTrendUp,
    FaBan,
    FaBell,
    FaBook,
    FaBuilding,
    FaBullhorn,
    FaCalendarDays,
    FaChartBar,
    FaChartSimple,
    FaCheck,
    FaCheckToSlot,
    FaChessQueen,
    FaChevronDown,
    FaChevronUp,
    FaCircleExclamation,
    FaCircleInfo,
    FaCircleQuestion,
    FaCircleXmark,
    FaClipboardList,
    FaClock,
    FaComment,
    FaComments,
    FaCompass,
    FaCopy,
    FaDollarSign,
    FaDownload,
    FaEarListen,
    FaEnvelope,
    FaEnvelopeCircleCheck,
    FaEnvelopeOpen,
    FaExclamation,
    FaEye,
    FaFile,
    FaFileCircleExclamation,
    FaFileCirclePlus,
    FaFileCsv,
    FaFileExport,
    FaFileInvoice,
    FaFileInvoiceDollar,
    FaFilePdf,
    FaFileZipper,
    FaFilter,
    FaFolderTree,
    FaFont,
    FaForwardStep,
    FaGavel,
    FaGear,
    FaGift,
    FaGlobe,
    FaGoogle,
    FaGraduationCap,
    FaHeadphones,
    FaHeadset,
    FaHourglassEnd,
    FaHourglassStart,
    FaIdCard,
    FaInfo,
    FaKey,
    FaLanguage,
    FaList,
    FaListCheck,
    FaLocationDot,
    FaMagnifyingGlassChart,
    FaMap,
    FaMobileScreenButton,
    FaMoneyBill,
    FaPaperPlane,
    FaPaperclip,
    FaPenRuler,
    FaPeopleGroup,
    FaPhone,
    FaPhoneSlash,
    FaPhoneVolume,
    FaPlay,
    FaPlus,
    FaProductHunt,
    FaQuestion,
    FaReceipt,
    FaArrowsRotate,
    FaRetweet,
    FaRightFromBracket,
    FaRoad,
    FaRotateLeft,
    FaScroll,
    FaMagnifyingGlass,
    FaServer,
    FaSquare,
    FaCommentSms,
    FaSortDown,
    FaSortUp,
    FaSpellCheck,
    FaSpinner,
    FaStar,
    FaTable,
    FaTag,
    FaTruck,
    FaTruckFast,
    FaUser,
    FaCircleUser,
    FaUsers,
    FaVolumeLow,
    FaX,
    FaXmark,
    FaRegAddressBook,
    FaRegClock,
    FaPenToSquare,
    FaTrash,
    FaClipboardQuestion,
    FaChartLine,
    FaBoxesPacking,
    FaCommentsDollar,
    FaCalendarWeek,
    FaElementor,
    FaBoxArchive,
    FaCashRegister,
    FaTruckRampBox,
    FaCreditCard,
    FaChalkboard,
    FaMeta,
    FaFileExcel,
    FaCircleCheck,
    FaUsps,
    FaReadme,
    FaHouse,
    FaAward,
    FaEuroSign,
} from "react-icons/fa6";
import { IoAdd } from "react-icons/io5";
import { FaFileUpload, FaPoll, FaSync, FaTasks, FaWindowClose, FaEdit, FaMinus, FaHome } from "react-icons/fa";

export const ICONS_MAP = {
    "copy": FaCopy,
    "edit": FaEdit,
    "trash": FaTrash,
    "add": IoAdd,
    "address-book": FaAddressBook,
    "address-book-o": FaRegAddressBook,
    "address-card": FaAddressCard,
    "arrow-down": FaArrowDown,
    "arrow-right": FaArrowRight,
    "arrow-right-arrow-left": FaArrowsRotate,
    "arrow-trend-up": FaArrowTrendUp,
    "ban": FaBan,
    "bar-chart": FaChartBar,
    "bell": FaBell,
    "book": FaBook,
    "building": FaBuilding,
    "bullhorn": FaBullhorn,
    "calendar": FaCalendarDays,
    "chart-simple": FaChartSimple,
    "check": FaCheck,
    "check-to-slot": FaCheckToSlot,
    "chess-queen": FaChessQueen,
    "chevron-down": FaChevronDown,
    "chevron-up": FaChevronUp,
    "circle-exclamation": FaCircleExclamation,
    "circle-info": FaCircleInfo,
    "circle-xmark": FaCircleXmark,
    "clipboard-list": FaClipboardList,
    "clock": FaClock,
    "clock-o": FaRegClock,
    "comment": FaComment,
    "comments": FaComments,
    "compass": FaCompass,
    "copy": FaCopy,
    "dollar": FaDollarSign,
    "download": FaDownload,
    "ear-listen": FaEarListen,
    "edit": FaPenToSquare,
    "envelope": FaEnvelope,
    "envelope-circle-check": FaEnvelopeCircleCheck,
    "envelope-open": FaEnvelopeOpen,
    "exclamation": FaExclamation,
    "eye": FaEye,
    "file": FaFile,
    "file-circle-exclamation": FaFileCircleExclamation,
    "file-circle-plus": FaFileCirclePlus,
    "file-csv": FaFileCsv,
    "file-export": FaFileExport,
    "file-invoice": FaFileInvoice,
    "file-invoice-dollar": FaFileInvoiceDollar,
    "file-pdf": FaFilePdf,
    "file-upload": FaFileUpload,
    "file-zipper": FaFileZipper,
    "filter": FaFilter,
    "folder-tree": FaFolderTree,
    "font": FaFont,
    "forward-step": FaForwardStep,
    "funnel-dollar": FaFileInvoiceDollar,
    "gavel": FaGavel,
    "gear": FaGear,
    "gift": FaGift,
    "globe": FaGlobe,
    "google": FaGoogle,
    "graduation-cap": FaGraduationCap,
    "headphones": FaHeadphones,
    "headset": FaHeadset,
    "hourglass-end": FaHourglassEnd,
    "hourglass-start": FaHourglassStart,
    "id-card": FaIdCard,
    "info": FaInfo,
    "info-circle": FaCircleInfo,
    "key": FaKey,
    "language": FaLanguage,
    "list": FaList,
    "location-dot": FaLocationDot,
    "magnifying-glass-chart": FaMagnifyingGlassChart,
    "map": FaMap,
    "mobile": FaMobileScreenButton,
    "money": FaMoneyBill,
    "money-bill": FaMoneyBill,
    "paper-plane": FaPaperPlane,
    "paperclip": FaPaperclip,
    "pen-ruler": FaPenRuler,
    "people-group": FaPeopleGroup,
    "phone": FaPhone,
    "phone-slash": FaPhoneSlash,
    "phone-volume": FaPhoneVolume,
    "play": FaPlay,
    "plus": FaPlus,
    "poll": FaPoll,
    "product-hunt": FaProductHunt,
    "question": FaQuestion,
    "question-circle": FaCircleQuestion,
    "receipt": FaReceipt,
    "refresh": FaArrowsRotate,
    "remove": FaXmark,
    "retweet": FaRetweet,
    "right-from-bracket": FaRightFromBracket,
    "road": FaRoad,
    "rotate-left": FaRotateLeft,
    "scroll": FaScroll,
    "search": FaMagnifyingGlass,
    "send": FaPaperPlane,
    "server": FaServer,
    "sharp": FaSquare,
    "sms": FaCommentSms,
    "sort-down": FaSortDown,
    "sort-up": FaSortUp,
    "spell-check": FaSpellCheck,
    "spin": FaSpinner,
    "spinner": FaSpinner,
    "star": FaStar,
    "sync": FaSync,
    "table": FaTable,
    "tag": FaTag,
    "tasks": FaTasks,
    "thin": FaMinus,
    "minus": FaMinus,
    "trash": FaTrash,
    "truck": FaTruck,
    "truck-fast": FaTruckFast,
    "user": FaUser,
    "user-circle": FaCircleUser,
    "users": FaUsers,
    "volume-low": FaVolumeLow,
    "window-close": FaWindowClose,
    "x": FaX,
    "xmark": FaXmark,
    "list-check": FaListCheck,
    "clipboard-question": FaClipboardQuestion,
    'chart-line': FaChartLine,
    'boxes-packing': FaBoxesPacking,
    'comments-dollar': FaCommentsDollar,
    'calendar-week': FaCalendarWeek,
    'elementor': FaElementor,
    'chart-bar': FaChartBar,
    'box-archive': FaBoxArchive,
    'home': FaHome,
    'cash-register': FaCashRegister,
    'truck-ramp-box': FaTruckRampBox,
    'credit-card': FaCreditCard,
    'chalkboard': FaChalkboard,
    'meta': FaMeta,
    'file-excel': FaFileExcel,
    'circle-check': FaCircleCheck,
    'usps': FaUsps,
    'arrows-rotate': FaArrowsRotate,
    'readme': FaReadme,
    'house': FaHouse,
    'award': FaAward,
    'euro-sign': FaEuroSign
};